import cx from 'classnames'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

import Typography from '../../Typography/Typography'

import './InputLayout.scss'

const InputLayout = ({ children, label, error, className, touched, color }) => {
    return (
        <Form.Group className={cx('input-layout w-100', className)}>
            {label && (
                <Form.Check.Label className={'mb-1'}>
                    <Typography variant={'formLabel'} color={error && touched ? 'error' : 'primary'}>
                        {label}
                    </Typography>
                </Form.Check.Label>
            )}
            <InputGroup hasValidation className={`input-layout--${color}`}>
                {children}
            </InputGroup>
            {error && touched && (
                <Form.Control.Feedback type="invalid" className={cx(error && touched && 'd-block m-0')}>
                    <Typography variant={'formDescription'} color={'error'} className={'position-absolute'}>
                        {error}
                    </Typography>
                </Form.Control.Feedback>
            )}
        </Form.Group>
    )
}

export default InputLayout
